export const getSafe = (fn, defaultVal) => {
    try {
        if (fn() === undefined || fn() === null) {
            return defaultVal
        }
        return fn();
    } catch (e) {
        return defaultVal;
    }
};

export default getSafe;